// extracted by mini-css-extract-plugin
module.exports = {"PageSubHeader":"styles_PageSubHeader__3g2P_","dashboardTitle":"styles_dashboardTitle__3Q4qy"};